var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "rounded-card mt-20" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "FormFieldsContainer",
            { attrs: { titulo: "Planes de Mantenimiento" } },
            [
              _c(
                "v-flex",
                { attrs: { md6: "" } },
                [
                  _c("BuscadorOperacionCrud", {
                    attrs: {
                      filter:
                        _vm.gridApi &&
                        _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { align: "left" } },
            [
              _c(
                "v-flex",
                [
                  _vm.accion === 3
                    ? _c("MantenedorGridVerDetalle", {
                        attrs: {
                          "grid-options": _vm.computedGridOptions,
                          "row-data": _vm.planesMantenimiento
                        }
                      })
                    : _c("AsociacionGrid", {
                        attrs: {
                          "grid-options": _vm.computedGridOptions,
                          esEditar: _vm.accion === 2 ? true : false
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }